<template>
  <p class="statement">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: 'Statement'
}
</script>

<style lang="scss" scoped>
.statement {
  opacity: 0.5;
  font-size: 18px;
  text-align: center;
  margin: 50px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Statement.vue